// 数値の桁区切り。画面ごとに Intl.NumberFormat を作らないよう共通化している。
const formatter = new Intl.NumberFormat('ja-JP');

export const formatNumber = (value: number): string => formatter.format(value);
